var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rating-services"},_vm._l((_vm.services),function(service,index){return _c('div',{key:index,staticClass:"rating-services__item"},[_vm._v("\n    "+_vm._s(service.label)+"\n\n    "),_c('RatingBar',{staticClass:"rating-card__bar",attrs:{"score":service.score}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }